/**
 * reportDebugError — schreibt einen sanitisierten Fehler-Entry in den
 * Debug-Layer (Section `errors`).
 *
 * Bewusst non-React, damit auch class-based ErrorBoundaries und
 * Edge-Function-Aufrufstellen das benutzen können. Der Helper macht
 * KEINE eigenen Backend-Calls; bestehende Reporter (z. B.
 * `clientErrorReporter`) laufen unverändert daneben weiter.
 */
import { addDebugEntry } from './state';
import type { DebugLayerEntry, DebugPayloadVisibility } from './types';

interface ReportInput {
  id?: string;
  scope: DebugLayerEntry['scope'];
  title: string;
  description?: string;
  severity?: 'warning' | 'error';
  route?: string;
  payload?: unknown;
  /** Default: `admin_safe`. Wer sensible Felder hat, muss `redacted` setzen. */
  payloadVisibility?: DebugPayloadVisibility;
}

let counter = 0;

export function reportDebugError(input: ReportInput): string {
  counter += 1;
  const id = input.id ?? `err-${Date.now()}-${counter}`;
  addDebugEntry({
    id,
    scope: input.scope,
    section: 'errors',
    title: input.title,
    description: input.description,
    severity: input.severity ?? 'error',
    route: input.route,
    payload: input.payload,
    payloadVisibility: input.payloadVisibility ?? 'admin_safe',
  });
  return id;
}
